// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"26494c1df6","253":"66928fbdee","619":"178d90e065"}[chunkId] + ".js";
};